import { render, staticRenderFns } from "./SpotsOrdersTable.vue?vue&type=template&id=5a6c37e0&"
import script from "./SpotsOrdersTable.vue?vue&type=script&lang=js&"
export * from "./SpotsOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports